const getters = {
  coupons: (state) => state.coupons,
  processing: (state) => state.processing,
};

export default getters;
